import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { chargebackCycleTypeDescriptions } from '../../utils/chargeBackCycles';
import _ from 'lodash';
import {
    getChargebackErrorMessage,
    getIsChargebackLoading,
    getChargeback,
    getDisputes,
    getDisputesErrorMessage,
    getIsChargebackDisputeLoading,
    getIsChargebackDisputeSuccessful,
    getIsDisputesLoading,
    getPreviewPdfErrorMessage,
    getIsPreviewPdfLoading,
    getPreviewPdfData,
    getChargebackDisputeErrorMessage
} from './chargebackEntity';
import { getTransactionLink } from '../Search/searchActions';
import {
    disputeChargeback,
    getChargeback as queryForChargeback,
    getDisputes as queryForDisputes,
    previewDisputeChargeback
} from './chargebackActions';
import {
    chargebacksShape as chargebackShape,
    disputeShape
} from '../../utils/propTypes';
import {
    EmvioLoadingSpinner as LoadingSpinner,
    EmvioRow as Row,
    EmvioCard as Card,
    EmvioTwoColumnItem as TwoColumnItem,
    browserDownload
} from '@nexio/emvio-util-ui';
import ErrorCard from '../ErrorCard/ErrorCard';
import {
    prettifyCardNumber,
    prettifyDate,
    prettifyDateNoTimeZone
} from '../../utils/string';
import DisputeForm from './DisputeForm/DisputeForm';
import {
    getProcessorTypeForMerchantId,
    getIsMerchantsLoading,
    getMerchantsMapper
} from '../Merchants/merchantsEntity';
import {
    getFullName,
    getDoesUserHaveWriteAccessForMerchant,
    getCustomAccess
} from '../Self/selfEntity';
import './Chargeback.scss';
import ActivityRow from './ActivityRow/ActivityRow';
import { toastIfError } from '../../utils/toast';
import {
    currencyMapper,
    doesPropExistAndHasItChanged,
    processorsWithDisputeEnabled,
    prettifyMoney,
    getDisputeByDate,
    cardTypesMapper
} from '@nexio/emvio-util-app';
import { getTimezone } from '../UserSettings/userSettingsEntity';
import { doesRoleHaveAccessToFeature } from '../../utils/customRole';
import config from '../../config/config';

export class Chargeback extends Component {
    static propTypes = {
        processor: PropTypes.number,
        chargeback: chargebackShape,
        disputes: PropTypes.arrayOf(disputeShape),
        disputesError: PropTypes.string,
        disputeSubmissionError: PropTypes.string,
        doesUserHaveWriteAccess: PropTypes.bool,
        error: PropTypes.string,
        fullName: PropTypes.string,
        isChargebackLoading: PropTypes.bool,
        isDisputesActivityLoading: PropTypes.bool,
        isDisputeSubmissionLoading: PropTypes.bool,
        isDisputeSubmissionSuccessful: PropTypes.bool,
        isMerchantsLoading: PropTypes.bool,
        match: PropTypes.shape({
            isExact: PropTypes.bool,
            params: PropTypes.shape({
                id: PropTypes.string
            }),
            path: PropTypes.string,
            url: PropTypes.string
        }),
        merchantMap: PropTypes.any,
        onGetChargebackById: PropTypes.func,
        onGetDisputesByChargebackId: PropTypes.func,
        onSubmitDispute: PropTypes.func,
        previewError: PropTypes.string,
        isPreviewPdfLoading: PropTypes.bool,
        previewPdfData: PropTypes.string,
        onPreviewPdf: PropTypes.func,
        timezone: PropTypes.string,
        customAccess: PropTypes.any
    };

    constructor(props) {
        super(props);

        this.renderDisputeForm = this.renderDisputeForm.bind(this);

        this.state = {};
    }

    componentDidMount() {
        this.props.onGetChargebackById(this.props.match.params.id);
    }

    componentDidUpdate(previousProps) {
        const chargebackId = _.get(this.props.chargeback, 'id');

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'chargeback') && this.props.chargeback.isDisputed && doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.chargeback]: ['GET/v3/dispute'] })) {
            const merchantId = _.get(this.props.chargeback, 'merchantId');

            this.props.onGetDisputesByChargebackId(chargebackId, merchantId);
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'isDisputeSubmissionSuccessful') && this.props.isDisputeSubmissionSuccessful === true) {
            this.props.onGetChargebackById(this.props.match.params.id);
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'previewPdfData')) {
            if (this.state.canOpenPreview) {
                browserDownload(`disputePreview${chargebackId}.pdf`, this.props.previewPdfData, 'application/pdf');
                this.setState({ canOpenPreview: false });
            }
        }

        toastIfError(previousProps, this.props);
        toastIfError(previousProps, this.props, 'disputesError');
        toastIfError(previousProps, this.props, 'previewError');
        toastIfError(previousProps, this.props, 'disputeSubmissionError');
    }

    handlePreviewDispute(description, files, chargebackWithMerchant) {
        this.props.onPreviewPdf(this.props.fullName, chargebackWithMerchant, description, files);
        this.setState({ canOpenPreview: true });
    }

    renderChargeback() {
        const chargeback = this.props.chargeback;
        const currencyId = _.get(chargeback, 'currencyId', '840');
        const currencyCode = currencyMapper[currencyId].code.toUpperCase();

        return (
            <Card
                className="grow-height half-width"
                HeaderComponent="Chargeback Info">
                <div className="two-column-container">
                    <TwoColumnItem
                        alterMethod={(reportDate) => prettifyDateNoTimeZone(reportDate)}
                        label="Date Posted"
                        value={chargeback.reportDate}
                    />
                    <TwoColumnItem
                        alterMethod={({ reportDate, chargebackCycle, processor }) => {
                            const processorType = _.get(processor, 'processorType');

                            return getDisputeByDate(reportDate, chargebackCycle, processorType, this.props.timezone);
                        }}
                        label="Dispute By"
                        value={chargeback}
                    />
                    <TwoColumnItem
                        label="Case #"
                        breakAll
                        value={chargeback.sequenceNumber}
                    />
                    <TwoColumnItem
                        label="Reference #"
                        breakAll
                        value={chargeback.referenceNumber}
                    />
                    <TwoColumnItem
                        alterMethod={(amount) => prettifyMoney(amount, currencyCode)}
                        label="Amount"
                        value={chargeback.amount}
                    />
                    <TwoColumnItem
                        label="Currency Code"
                        value={currencyCode}
                    />
                    <TwoColumnItem
                        label="Reason Code"
                        value={_.trimStart(chargeback.reasonCode, '0')}
                    />
                    <TwoColumnItem
                        label="Reason Description"
                        value={_.get(chargeback, 'reason.description')}
                    />
                    <TwoColumnItem
                        label="Funds Moved"
                        value={_.get(chargeback, 'fundsMoved') === 1 ? 'True' : 'False'}
                    />
                </div>
            </Card>
        );
    }

    renderTransactionId = (id) => {
        return (<Link className="transaction-clickthrough-link" to={getTransactionLink({ id })}>Open original transaction</Link>);
    };

    renderTransactionInfo() {
        const { chargeback } = this.props;
        const orderNumber = _.get(chargeback, 'transaction.orderNumber')
            || _.get(chargeback, 'transaction.plugin.orderNumber');
        const transactionId = _.get(chargeback, 'transaction.transactionId')
            || _.get(chargeback, 'transactionId')
            || _.get(chargeback, 'transaction.id');
        const currencyId = _.get(chargeback, 'currencyId', '840');
        const currencyCode = currencyMapper[currencyId].code.toUpperCase();
        const amount = _.get(chargeback, 'transaction.amount')
            || _.get(chargeback, 'amount');
        const cardType = _.toUpper(cardTypesMapper[_.get(chargeback, 'cardType')]) || _.toUpper(_.get(chargeback, 'cardType'));

        return (
            <Card
                className="grow-height half-width"
                HeaderComponent="Transaction Info">
                <div className="two-column-container">
                    {doesRoleHaveAccessToFeature(this.props.customAccess, { [config.serviceArns.transaction]: ['GET/v3/{id}'] })
                        ? <TwoColumnItem
                            alterMethod={this.renderTransactionId}
                            label=""
                            value={transactionId}
                        />
                        : null
                    }
                    <TwoColumnItem
                        alterMethod={(transactionDate) => prettifyDate(transactionDate, { truncateZeroTimes: true })}
                        label="Transaction Date"
                        value={chargeback.transaction ? chargeback.transaction.transactionDate : chargeback.transactionDate}
                    />
                    <TwoColumnItem
                        label="Merchant"
                        value={this.props.merchantMap[chargeback.merchantId]}
                    />
                    <TwoColumnItem
                        label="Merchant ID"
                        breakAll
                        value={chargeback.merchantId}
                    />
                    <TwoColumnItem
                        label="Card Holder"
                        breakAll
                        value={_.startCase(_.get(chargeback, 'transaction.cardHolder'))}
                    />
                    <TwoColumnItem
                        alterMethod={prettifyCardNumber}
                        label="Card Number"
                        value={chargeback.cardNumber}
                    />
                    <TwoColumnItem
                        alterMethod={(amount) => prettifyMoney(amount, currencyCode)}
                        label="Transaction Amount"
                        value={amount}
                    />
                    <TwoColumnItem
                        label="Currency Code"
                        value={currencyCode}
                    />
                    <TwoColumnItem
                        label="Card Type"
                        value={cardType}
                    />
                    <TwoColumnItem
                        label="Auth Code"
                        breakAll
                        value={chargeback.authCode}
                    />
                    <TwoColumnItem
                        label="Order ID"
                        value={orderNumber}
                    />
                </div>
            </Card>
        );
    }

    renderDisputeForm() {
        const chargebackWithMerchant = {
            ...this.props.chargeback,
            merchantName: this.props.merchantMap[this.props.chargeback.merchantId]
        };

        if ((_.toString(this.props.chargeback.merchantId).startsWith('5') || _.toString(this.props.chargeback.merchantId).startsWith('8') ||
        _.toString(this.props.chargeback.merchantId).startsWith('0008')) && !_.get(this.props, 'chargeback.sequenceNumber')) {
            return (
                <span className="footnote">* To Dispute this chargeback, please contact the Chargeback Department at 800-858-1166.</span>
            );
        } else {
            return (
                <Row>
                    <DisputeForm
                        onPreviewDispute={(description, files) => this.handlePreviewDispute(description, files, chargebackWithMerchant)}
                        onSubmit={this.props.onSubmitDispute(this.props.fullName, chargebackWithMerchant)}
                        canUserDispute={this.props.doesUserHaveWriteAccess}
                        isLoading={this.props.isDisputeSubmissionLoading}
                        isPreviewLoading={this.props.isPreviewPdfLoading}
                        merchantId={this.props.chargeback.merchantId}
                    />
                </Row>
            );
        }
    }

    renderActivitySection() {
        const merchantId = this.props.chargeback.merchantId;

        const activityRows = this.props.disputes.map((dispute) => {
            return <ActivityRow
                key={dispute.id}
                dispute={dispute}
                chargebackId={this.props.chargeback.id}
                merchantId={merchantId} />;
        });

        return (
            <Row>
                <Card HeaderComponent="Activity" className="activity-card grow-height">
                    {activityRows}
                </Card>
            </Row>
        );
    }

    renderBottomCard() {
        const {
            chargeback,
            processor,
            isDisputesActivityLoading,
            isMerchantsLoading,
            disputes
        } = this.props;

        if (chargeback.chargebackCycle !== 0 && chargeback.sequenceNumber) {
            if (isMerchantsLoading || (chargeback.isDisputed && isDisputesActivityLoading)) {
                return (
                    <Row>
                        <Card>
                            <LoadingSpinner />
                        </Card>
                    </Row>
                );
            } else if (!chargeback.isDisputed && processorsWithDisputeEnabled.includes(processor) && (chargeback.chargebackCycle === 1 && chargeback.amount < 0)) {
                return this.renderDisputeForm();
            } else if (_.size(disputes)) {
                return this.renderActivitySection();
            }
        }
    }

    renderMissingCaseNumInfo() {
        const { chargeback } = this.props;

        if (!chargeback.sequenceNumber) {
            const merchantIdStr = _.toString(chargeback.merchantId);
            let phoneNumber = '866-637-5467';
            let optionText = '';

            if (merchantIdStr.startsWith('5') || merchantIdStr.startsWith('8') || merchantIdStr.startsWith('0008')) {
                phoneNumber = '800-858-1166';
                optionText = ' and choose option 1';
            }

            return (
                <Row>
                    <Card className="case-num-card">
                        For more information about this chargeback, contact Customer Support at {phoneNumber}{optionText}.
                    </Card>
                </Row>
            );
        }
    }

    renderStatus({ chargebackCycle }) {
        let statusLabel = 'Unknown';

        if (chargebackCycle === 2) {
            statusLabel = 'Won';
        } else if (chargebackCycle === 4) {
            statusLabel = 'Final';
        } else if (chargebackCycle === 4.1) {
            statusLabel = 'Final (Closed)';
        } else if (chargebackCycle === 1) {
            statusLabel = 'Initial';
        } else if (chargebackCycle === 3) {
            statusLabel = 'Representment';
        } else if (chargebackCycle === 3.1) {
            statusLabel = 'Representment (Open)';
        } else if (chargebackCycle === 3.2) {
            statusLabel = 'Representment (Closed)';
        } else if (chargebackCycle === 0) {
            statusLabel = 'Canceled';
        }

        return (
            <Card className="status-card">
                <div className="status-container">
                    <div className="status-header">
                        Cycle Type <span className="chargeback-status">{chargebackCycle}: {statusLabel}</span>
                    </div>
                    <div className="status-description-container">
                        <p>{chargebackCycleTypeDescriptions[chargebackCycle]}</p>
                    </div>
                </div>
            </Card>
        );
    }

    render() {
        if (this.props.isChargebackLoading) {
            return (<LoadingSpinner />);
        } else if (this.props.chargeback && !this.props.error) {
            return (
                <div className="emvio-chargeback">
                    <Row>
                        {this.renderStatus(this.props.chargeback)}
                    </Row>
                    <Row>
                        {this.renderChargeback()}
                        {this.renderTransactionInfo()}
                    </Row>
                    {this.renderBottomCard()}
                    {this.renderMissingCaseNumInfo()}
                </div>
            );
        } else {
            return (
                <div className="emvio-chargeback">
                    <Row>
                        <ErrorCard />
                    </Row>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    const chargeback = getChargeback(state);
    const merchantId = _.get(chargeback, 'merchantId');
    const chargebackId = _.get(chargeback, 'id');

    return {
        chargeback,
        disputes: getDisputes(state),
        disputesError: getDisputesErrorMessage(state),
        disputeSubmissionError: getChargebackDisputeErrorMessage(state),
        doesUserHaveWriteAccess: getDoesUserHaveWriteAccessForMerchant(state, merchantId),
        error: getChargebackErrorMessage(state),
        fullName: getFullName(state),
        isChargebackLoading: getIsChargebackLoading(state),
        isDisputeSubmissionLoading: getIsChargebackDisputeLoading(state),
        isDisputesActivityLoading: getIsDisputesLoading(state),
        isDisputeSubmissionSuccessful: getIsChargebackDisputeSuccessful(state),
        isMerchantsLoading: getIsMerchantsLoading(state),
        merchantMap: getMerchantsMapper(state),
        processor: getProcessorTypeForMerchantId(state, merchantId),
        previewError: getPreviewPdfErrorMessage(state, chargebackId),
        isPreviewPdfLoading: getIsPreviewPdfLoading(state, chargebackId),
        previewPdfData: getPreviewPdfData(state, chargebackId),
        timezone: getTimezone(state),
        customAccess: getCustomAccess(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetChargebackById: (id) => dispatch(queryForChargeback(id)),
        onGetDisputesByChargebackId: (chargebackId, merchantId) => dispatch(queryForDisputes(chargebackId, merchantId)),
        onSubmitDispute: (userName, chargeback) => (description, images) => disputeChargeback(userName, chargeback, description, images, dispatch),
        onPreviewPdf: (userName, chargeback, description, images) => previewDisputeChargeback(userName, chargeback, description, images, dispatch)
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Chargeback));
